export default __webpack_public_path__ + "static/media/Eyeball.eb1d3d63.svg";